<p-table
  [value]="subscriptionClients$ | async"
  [loading]="showSkeleton"
  styleClass="my-1"
  responsiveLayout="scroll"
>
  <ng-template pTemplate="header">
    <tr>
      <th class="surface-100 border-0 py-2">
        <span class="text-xs text-600 white-space-nowrap">{{
          'SUBSCRIPTIONS.CLIENTS.CLIENT_NAME' | translate
        }}</span>
      </th>
      <th class="surface-100 border-0 py-2">
        <span class="text-xs text-600 white-space-nowrap">{{
          'SUBSCRIPTIONS.CLIENTS.START_DATE' | translate
        }}</span>
      </th>
      <th class="surface-100 border-0 py-2">
        <span class="text-xs text-600 white-space-nowrap">{{
          'SUBSCRIPTIONS.CLIENTS.END_DATE' | translate
        }}</span>
      </th>
    </tr>
  </ng-template>
  <ng-template pTemplate="loadingbody" let-columns>
    <tr>
      <td>
        <p-skeleton width="85%" height="2rem" />
      </td>
      <td>
        <p-skeleton width="60%" height="2rem" />
      </td>
      <td>
        <p-skeleton width="60%" height="2rem" />
      </td>
    </tr>
    <tr>
      <td>
        <p-skeleton width="75%" height="2rem" />
      </td>
      <td>
        <p-skeleton width="50%" height="2rem" />
      </td>
      <td>
        <p-skeleton width="50%" height="2rem" />
      </td>
    </tr>
  </ng-template>
  <ng-template pTemplate="emptymessage">
    <tr>
      <td colspan="3" class="text-center p-4">
        <div class="text-600">{{ 'SUBSCRIPTIONS.NO_CLIENTS' | translate }}</div>
      </td>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-client>
    <tr class="text-sm">
      <td class="py-2 white-space-nowrap">
        <strong>{{ client.full_name }}</strong> - {{ client.id }}
      </td>
      <td class="py-2 white-space-nowrap">
        {{ client.start_date | datetimeformat: 'MMM d, yy' }}
      </td>
      <td class="py-2 white-space-nowrap">
        {{ client.end_date | datetimeformat: 'MMM d, yy' }}
      </td>
    </tr>
  </ng-template>
</p-table>
